/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
==========================================================================================*/

import vm from "../../main.js";

import pouch from "@/db/pouch";

export default {
  addOperator({ commit }, operator) {
    return new Promise(async (resolve, reject) => {
      try {
        return await pouch.en(operator).then(async (eo) => {
          return await pouch
            .f(
              {
                selector: {
                  c: eo.c,
                  z: 3,
                },
              },
              true,
              false
            )
            .then(async (sr) => {
              if (sr.hasOwnProperty("a")) {
                return reject(
                  "An operator exists with this ID number. Try again with a different ID number."
                );
              } else {
                return await pouch.c(eo, true).then((co) => {
                  if (co.ok) {
                    return resolve("Operator successfully registered");
                  }
                  return reject(co.message);
                });
              }
            });
        });
      } catch (e) {
        return reject(e);
      }
    });
  },
  updateOperator({ commit }, operator) {
    return new Promise(async (resolve, reject) => {
      return await pouch
        .f(
          {
            selector: {
              _id: operator._id,
              z: 3,
            },
          },
          true,
          false
        )
        .then(async (sr) => {
          if (sr.hasOwnProperty("a")) {
            return await pouch
              .c(operator, false)
              .then((ct) => {
                if (ct.ok) {
                  return resolve("Operator successfully updated");
                }
                return reject(ct.message);
              })
              .catch((e) => reject(e));
          } else {
            return reject(
              "This operator has not been found. He/she might no longer exist in your database."
            );
          }
        });
    });
  },
};
